import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-play\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M17.54,11.06l-8-5.48A1,1,0,0,0,8,6.4v11a1,1,0,0,0,1.57.83l8-5.49A1,1,0,0,0,17.54,11.06Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol